module.exports = __webpack_public_path__ + "static/media/pak-alif.65389a24.jpeg";